export default class TrackerController {
  constructor(resource) {
    this._resource = resource;
  }

  getAllTracker() {
    return this._resource('tracker')
      .get()
      .then(res => res.json())
      .catch(error => console.log(error));
  }

  async getStatus() {
    return await this._resource('tracker/status')
      .get()
      .then(res => res.json())
      .catch(err => {
        throw err;
      });
  }
}
